import mediaQueries from 'styles/mediaQueries';
import mediaQueryBuilder from 'styles/helpers/mediaQueryBuilder';
import styled from '@emotion/styled';

type Props = {
  'data-test'?: string;
  show: boolean;
};

const Time = styled('span')<Props>(({ show, theme }) => ({
  color: theme.timeColor,
  opacity: show ? 1 : 0,
  position: 'absolute',
  transform: 'translate3d(0, -100%, 0)',
  transition: 'opacity 300ms ease',

  [mediaQueryBuilder(
    mediaQueries.max.height['149'],
    mediaQueries.max.width['225'],
  )]: {
    display: 'none',
  },
}));

export default Time;
